/**
 * @generated SignedSource<<17c74efe4e25be89f3acdfc1f206fab1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineDetailScreenTopContributor_Routine$data = {
  readonly topContributors: ReadonlyArray<{
    readonly count: number;
    readonly user: {
      readonly id: string;
      readonly name: string;
    } | null;
  }>;
  readonly " $fragmentType": "RoutineDetailScreenTopContributor_Routine";
};
export type RoutineDetailScreenTopContributor_Routine$key = {
  readonly " $data"?: RoutineDetailScreenTopContributor_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineDetailScreenTopContributor_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineDetailScreenTopContributor_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineUserContributor",
      "kind": "LinkedField",
      "name": "topContributors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "fdfdd22493a15c9b3f32fd242c4ec6af";

export default node;
